import React, { useState } from 'react';
import RechargeForm from './RechargeForm';
import ConsumeForm from './ConsumeForm';
import './MainAccountCard.css';

/**
 * 主账户概览卡片组件
 * 
 * @param {Object} props
 * @param {String} props.courtId - 场地ID
 * @param {Object} props.court - 场地信息（包含rechargeRate）
 * @param {Object} props.overview - 主账户概览数据
 * @param {Function} props.onRefresh - 刷新回调
 */
const MainAccountCard = ({ courtId, court, overview, onRefresh }) => {
  const [showRechargeForm, setShowRechargeForm] = useState(false);
  const [showConsumeForm, setShowConsumeForm] = useState(false);

  if (!overview) {
    return (
      <div className="main-account-card">
        <div className="empty-state">
          <p>暂无数据</p>
        </div>
      </div>
    );
  }

  // 计算金额（场时数 × 换算率）
  const calculateAmount = (courtTime) => {
    if (!court || !court.rechargeRate) return null;
    return (courtTime * court.rechargeRate).toFixed(2);
  };

  const balanceAmount = calculateAmount(overview.currentBalance);

  return (
    <div className="main-account-card">
      {/* 余额卡片 */}
      <div className="balance-card">
        <div className="balance-header">
          <h2>主账户余额</h2>
          <div className="balance-stats-row">
            {/* 余额 */}
            <div className="balance-stat-item">
              <div className={`balance-amount ${overview.currentBalance < 0 ? 'negative' : ''}`}>
                {overview.currentBalance.toFixed(2)}
                <span className="balance-unit">场时</span>
              </div>
              {balanceAmount && (
                <div className={`balance-money ${overview.currentBalance < 0 ? 'negative' : ''}`}>
                  ¥{balanceAmount}
                  <span className="balance-unit">元</span>
                </div>
              )}
            </div>
            
            {/* 总充值 */}
            <div className="balance-stat-item">
              <div className="stat-label">总充值</div>
              <div className="stat-value">{overview.totalRecharged.toFixed(2)} 场时</div>
              <div className="stat-count">({overview.rechargeCount} 次)</div>
            </div>
            
            {/* 总消费 */}
            <div className="balance-stat-item">
              <div className="stat-label">总消费</div>
              <div className="stat-value">{overview.totalConsumed.toFixed(2)} 场时</div>
              <div className="stat-count">({overview.consumeCount} 次)</div>
            </div>
          </div>
        </div>

        {/* 操作按钮 */}
        <div className="action-buttons">
          <button
            className="action-button recharge-button"
            onClick={() => setShowRechargeForm(true)}
          >
            ➕ 充值
          </button>
          <button
            className="action-button consume-button"
            onClick={() => setShowConsumeForm(true)}
          >
            ➖ 消费
          </button>
        </div>
      </div>

      {/* 充值表单 */}
      {showRechargeForm && (
        <RechargeForm
          courtId={courtId}
          onClose={() => setShowRechargeForm(false)}
          onSuccess={() => {
            setShowRechargeForm(false);
            onRefresh();
          }}
        />
      )}

      {/* 消费表单 */}
      {showConsumeForm && (
        <ConsumeForm
          courtId={courtId}
          onClose={() => setShowConsumeForm(false)}
          onSuccess={() => {
            setShowConsumeForm(false);
            onRefresh();
          }}
        />
      )}
    </div>
  );
};

export default MainAccountCard;

